import axios from "axios";
import store from "store";
import {
    EventBus
} from "../Bus";

const TOKEN_KEY = "mm-chat.token";

const ERROR_CODE = {
    AUTH: 406
};

const http = axios.create({
    baseURL: global.API_URI || "http://mm-chat.demo2.mixmedia.com/api",
});

http.interceptors.request.use((config) => {
    config = Object.assign(config, {
        headers: {
            Authorization: store.get(TOKEN_KEY) || "",
        }
    });
    return config;
});

http.interceptors.response.use(resp => {
    let json = resp.data;
    if (json && json.status === 1) {
        return json.data;
    }
    if (json && json.error) {
        if (json.error.code === ERROR_CODE.AUTH) {
            EventBus.dispatchAuthError();
        }
        return Promise.reject(json.error);
    }

    return Promise.reject();
});

export default {
    /**
     * @param {string?} url
     * @param {import("axios").AxiosRequestConfig?} config
     * @returns {Promise<any>}
     */
    get(url, config) {
        return http.get(...arguments);
    },
    /**
     *
     * @param {string?} url
     * @param {any?} data
     * @param  {import("axios").AxiosRequestConfig?} config
     * @returns {Promise<any>}
     */
    post(url, data, config) {
        return http.post(...arguments);
    }
}
